module.exports = __webpack_public_path__ + "img/m-rp-logo.4f934a39.png";